module.exports = __webpack_public_path__ + "static/media/shippingeBay.8ee54a8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/modal/shippingeBay.jpg
// module id = 1676
// module chunks = 0